export default {
  edit_note: 'Modifier la note',
  add_note: 'Ajouter une note ',
  update: "Mettre à jour l'article",
  feedback: {
    item_sold_out_one: 'Nous sommes désolés, mais {{items}} est actuellement épuisé.',
    item_sold_out_other: 'Nous sommes désolés, mais {{items}} est actuellement épuisé.',
    item_unavailable:
      "Cet article est disponible uniquement à partir de {{schedule}}. Veuillez modifier l'heure de la commande ou supprimer l'article.",
  },
  buttons: {
    update: 'Mettre à jour',
  },
};
